import { useTheme } from '@mui/material';

export const useSxStyles = () => {
  const theme = useTheme();

  return {
    dialogContent: {
      paddingTop: 0,
      paddingBottom: theme.spacing(3),
    },
    errorMessage: {
      margin: 'auto',
      textAlign: 'center',
    },
    root: {
      display: 'flex',
      flexDirection: 'column',
      flexGrow: 1,
      overflow: 'hidden',
    },
  };
};
